import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  payments: []
};

const slice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getPaymentsSuccess(state, action) {
      state.payments = action.payload;
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getPaymentsSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function loadPayments() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/account/my/payments');
      dispatch(slice.actions.getPaymentsSuccess(response.data.records ? response.data.records : []));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export const getPayments = state => state.payments;